module.exports = __webpack_public_path__ + "static/media/banner-mobile.95d1de67.png";